var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-gray-100 dark:bg-gray-800",attrs:{"id":"app"}},[_c('Minesweeper')],1)}
var staticRenderFns = []

export { render, staticRenderFns }